import { useEffect, useState } from "react";

import { bootstrapAuthentication } from "../api/api";
import { clearSensitiveClientState } from "../auth/tokenStore";
import { getSessionEndMessage, SILENT_SESSION_END_KEY } from "../auth/sessionEndMessages.mjs";
import { persistor } from "../Redux/store";
import { getStoredFirmLoginPath } from "../auth/firmLogin.mjs";

export const AuthSessionGate = ({ children }) => {
  const [ready, setReady] = useState(false);
  const [webSocketAlert, setWebSocketAlert] = useState(null);

  useEffect(() => {
    let mounted = true;

    const handleSessionEnded = async (event) => {
      const reason = event.detail?.reason || "session_ended";
      // Intentional logout and timeout can race with socket closures caused by
      // the server logout. Preserve a selected timeout message, or keep a
      // user-initiated logout silent, instead of displaying the socket reason.
      const isSilentLogout = sessionStorage.getItem(SILENT_SESSION_END_KEY) === "true";
      const message = isSilentLogout
        ? null
        : sessionStorage.getItem("auth_end_message") || getSessionEndMessage(reason);
      if (message) {
        sessionStorage.setItem("auth_end_message", message);
      } else {
        sessionStorage.removeItem("auth_end_message");
      }
      persistor.pause();
      await persistor.flush();
      await persistor.purge();
      clearSensitiveClientState();
      window.location.replace(getStoredFirmLoginPath());
    };

    window.addEventListener("auth-session-ended", handleSessionEnded);
    const handleWebSocketStatus = (event) => {
      setWebSocketAlert(event.detail || null);
    };
    const clearWebSocketStatus = (event) => {
      setWebSocketAlert((current) => {
        if (!current || !event.detail?.path || current.path === event.detail.path) {
          return null;
        }
        return current;
      });
    };
    window.addEventListener("bp-websocket-status", handleWebSocketStatus);
    window.addEventListener("bp-websocket-status-clear", clearWebSocketStatus);
    bootstrapAuthentication()
      .catch(() => false)
      .finally(() => {
        if (mounted) setReady(true);
      });

    return () => {
      mounted = false;
      window.removeEventListener("auth-session-ended", handleSessionEnded);
      window.removeEventListener("bp-websocket-status", handleWebSocketStatus);
      window.removeEventListener("bp-websocket-status-clear", clearWebSocketStatus);
    };
  }, []);

  if (!ready) return null;
  return (
    <>
      {webSocketAlert && (
        <div className="alert alert-danger mb-0" role="alert" aria-live="assertive">
          <span>{webSocketAlert.message}</span>
          <button
            type="button"
            className="btn-close float-end"
            aria-label="Dismiss WebSocket error"
            onClick={() => setWebSocketAlert(null)}
          />
        </div>
      )}
      {children}
    </>
  );
};

export default AuthSessionGate;
